import { render, staticRenderFns } from "./ThgRating.vue?vue&type=template&id=381dbfa3"
import script from "./ThgRating.vue?vue&type=script&lang=ts"
export * from "./ThgRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports